import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useState, useCallback, useMemo } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Tabs from '@atlaskit/tabs';
import Modal, { ModalBody } from '@atlaskit/modal-dialog';
import { Box, xcss } from '@atlaskit/primitives';
import { NUMBER_OF_REACTIONS_TO_DISPLAY } from '../../shared/constants';
import { ReactionsList } from './ReactionsList';
import { ReactionsDialogHeader } from './ReactionsDialogHeader';
import { containerStyle } from './styles';

/**
 * Test id for the Reactions modal dialog
 */
export var RENDER_MODAL_TESTID = 'render-reactions-modal';
var modalBodyStyle = xcss({
  marginBottom: 'space.300'
});
export var ReactionsDialog = function ReactionsDialog(_ref) {
  var _currentReactions$;
  var _ref$reactions = _ref.reactions,
    reactions = _ref$reactions === void 0 ? [] : _ref$reactions,
    _ref$handleCloseReact = _ref.handleCloseReactionsDialog,
    handleCloseReactionsDialog = _ref$handleCloseReact === void 0 ? function () {} : _ref$handleCloseReact,
    emojiProvider = _ref.emojiProvider,
    selectedEmojiId = _ref.selectedEmojiId,
    _ref$handleSelectReac = _ref.handleSelectReaction,
    handleSelectReaction = _ref$handleSelectReac === void 0 ? function () {} : _ref$handleSelectReac,
    _ref$handlePagination = _ref.handlePaginationChange,
    handlePaginationChange = _ref$handlePagination === void 0 ? function () {} : _ref$handlePagination,
    ProfileCardWrapper = _ref.ProfileCardWrapper;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasNavigatedPages = _useState2[0],
    setHasNavigatedPages = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var totalReactionsCount = useMemo(function () {
    return reactions.reduce(function (accum, current) {
      return accum += current === null || current === void 0 ? void 0 : current.count;
    }, 0);
  }, [reactions]);
  var maxPages = Math.max(1, Math.ceil(reactions.length / NUMBER_OF_REACTIONS_TO_DISPLAY));
  var currentReactions = useMemo(function () {
    var start = (currentPage - 1) * NUMBER_OF_REACTIONS_TO_DISPLAY;
    var end = start + NUMBER_OF_REACTIONS_TO_DISPLAY;
    return reactions.slice(start, end);
  }, [reactions, currentPage]);
  var handleNextPage = function handleNextPage() {
    setCurrentPage(function (prevPage) {
      return Math.min(prevPage + 1, maxPages);
    });
    setHasNavigatedPages(true);
  };
  var handlePreviousPage = function handlePreviousPage() {
    setCurrentPage(function (prevPage) {
      return Math.max(prevPage - 1, 1);
    });
    setHasNavigatedPages(true);
  };
  var firstEmojiOnPage = (_currentReactions$ = currentReactions[0]) === null || _currentReactions$ === void 0 ? void 0 : _currentReactions$.emojiId;
  useEffect(function () {
    // trigger the handler with the first emoji when the page changes
    if (hasNavigatedPages && firstEmojiOnPage) {
      handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
    }
  }, [hasNavigatedPages, currentPage, maxPages, firstEmojiOnPage, handlePaginationChange]);

  /* set Reactions Border Width , 8 Number of reactions to display*/
  var reactionsBorderWidth = useMemo(function () {
    return Math.ceil(reactions.length / NUMBER_OF_REACTIONS_TO_DISPLAY) * 100;
  }, [reactions]);
  var selectedIndex = currentReactions.findIndex(function (reaction) {
    return reaction.emojiId === selectedEmojiId;
  });
  var onTabChange = useCallback(function (index) {
    if (index === selectedIndex) {
      return;
    }
    var emojiId = currentReactions[index].emojiId;
    handleSelectReaction(emojiId);
  }, [selectedIndex, currentReactions, handleSelectReaction]);
  return jsx(Modal, {
    onClose: handleCloseReactionsDialog,
    height: 600,
    testId: RENDER_MODAL_TESTID
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: false
  }, jsx(Tabs, {
    id: "reactions-dialog-tabs",
    onChange: onTabChange,
    selected: selectedIndex
  }, jsx(ReactionsDialogHeader, {
    totalReactionsCount: totalReactionsCount,
    maxPages: maxPages,
    handlePreviousPage: handlePreviousPage,
    handleNextPage: handleNextPage,
    currentPage: currentPage,
    emojiProvider: emojiProvider,
    currentReactions: currentReactions,
    handleCloseReactionsDialog: handleCloseReactionsDialog
  }), jsx(ModalBody, null, jsx(Box, {
    xcss: modalBodyStyle
  }, jsx("div", {
    css: containerStyle(reactionsBorderWidth)
  }, jsx(ReactionsList, {
    selectedEmojiId: selectedEmojiId,
    reactions: currentReactions,
    ProfileCardWrapper: ProfileCardWrapper
  }))))));
};